import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import moment from 'moment';
import sha1 from 'js-sha1';

Vue.use(Vuex)

axios.defaults.baseURL = process.env.VUE_APP_BACKEND_BASE_PATH;

//Numero giorni da sottrarre
const defaultLowerBound = 7;

function getDigest(request) {
  return sha1(process.env.VUE_APP_DIGEST_SALT + JSON.stringify(request));
}

if (process.env.VUE_APP_BASIC_AUTH === true) {
  axios.defaults.headers['Authorization'] = `Basic ZW1vbkZFOkZFUGFzc3dvcmQ=`;
}

export default new Vuex.Store({
  
  state: { //Variabili\Parametri su localstorage
    token: localStorage.getItem('access_token') || null,
    userType: localStorage.getItem('user_type') || null, //'standard','advanced','admin','superadmin'
    clientRole: localStorage.getItem('client_role') || null, //'standard', 'master'
    clientId: localStorage.getItem('client_id') || null,
    clientName: localStorage.getItem('client_name') || null,
    clientLogo: localStorage.getItem('client_logo') || null,
    slaveClients: localStorage.getItem('slave_clients') || null,
    selectedSlaveClient: localStorage.getItem('selected_slave_client') || null,
    clientSites: localStorage.getItem('client_sites') || null,
    clientSiteDefaultSiteId: localStorage.getItem('client_site_default_site_id') || null,
    selectedSite: localStorage.getItem('selected_site') || null,
    selectedSiteFull: localStorage.getItem('selected_site_full') || null,
    loading: 0,

    selectedDashboard: localStorage.getItem('selected_dashboard') || null,
    /* Acquisitions */
    selectedAcquisitionsDevices: localStorage.getItem('selected_acquisitions_devices') || null,
    selectedAcquisitionsParameters: localStorage.getItem('selected_acquisitions_parameters') || null,
    
    selectedAcquisitionsAggregationFrequency: localStorage.getItem('selected_acquisitions_aggregation_frequency') || null,
    selectedAcquisitionsAggregationMode: localStorage.getItem('selected_acquisitions_aggregation_mode') || null,
    selectedAcquisitionsLowerbound: localStorage.getItem('selected_acquisitions_lowerbound') || null,
    selectedAcquisitionsUpperbound: localStorage.getItem('selected_acquisitions_upperbound') || null,
    /* End Acquisitions */
    
    /* Consumptions */
    selectedConsumptionsDevices: localStorage.getItem('selected_consumptions_devices') || null,
    selectedConsumptionsParameters: localStorage.getItem('selected_consumptions_parameters') || null,
    
    selectedConsumptionsAggregationFrequency: localStorage.getItem('selected_consumptions_aggregation_frequency') || null,
    selectedConsumptionsAggregationMode: localStorage.getItem('selected_consumptions_aggregation_mode') || null,
    selectedConsumptionsLowerbound: localStorage.getItem('selected_consumptions_lowerbound') || null,
    selectedConsumptionsUpperbound: localStorage.getItem('selected_consumptions_upperbound') || null,
    /* End Consumptions*/

    /* Alarms */
    selectedAlarmsDevices: localStorage.getItem('selected_alarms_devices') || null,
    selectedAlarmsParameters: localStorage.getItem('selected_alarms_parameters') || null,
    
    selectedAlarmsLowerbound: localStorage.getItem('selected_alarms_lowerbound') || null,
    selectedAlarmsUpperbound: localStorage.getItem('selected_alarms_upperbound') || null,
    /* End Alarms*/

    /* Reports */
    selectedReport: localStorage.getItem('selected_report') || null,
    
    selectedReportLowerbound: localStorage.getItem('selected_report_lowerbound') || null,
    selectedReportUpperbound: localStorage.getItem('selected_report_upperbound') || null,
    /* End Reports*/
  },

  getters: { //Metodi getters su localstorage
    loading(state) {
      return state.loading
    },
    loggedIn(state) {
      return state.token !== null
    },
    token(state) {
      return state.token
    },
    userType(state) {
      return state.userType
    },
    clientId(state) {
      return parseInt(state.clientId)
    },
    clientName(state) {
      return state.clientName
    },
    clientLogo(state) {
      return state.clientLogo
    },
    clientRole(state) {
      return state.clientRole
    },
    slaveClients(state) {
      return JSON.parse(state.slaveClients)
    },
    selectedSlaveClient(state) {
      return JSON.parse(state.selectedSlaveClient)
    },
    clientSites(state) {
      return JSON.parse(state.clientSites)
    },
    clientSiteDefaultSiteId(state) {
      return state.clientSiteDefaultSiteId
    },
    selectedSite(state) {
      return state.selectedSite
    },
    selectedSiteFull(state) {
      return JSON.parse(state.selectedSiteFull)
    },
    selectedDashboard(state) {
      return JSON.parse(state.selectedDashboard)
    },

    /* Acquisitions */
    selectedAcquisitionsDevices(state) {
      return JSON.parse(state.selectedAcquisitionsDevices)
    },
    selectedAcquisitionsParameters(state) {
      return JSON.parse(state.selectedAcquisitionsParameters)
    },
    selectedAcquisitionsAggregationFrequency(state) {
      return JSON.parse(state.selectedAcquisitionsAggregationFrequency)
    },
    selectedAcquisitionsAggregationMode(state) {
      return JSON.parse(state.selectedAcquisitionsAggregationMode)
    },
    selectedAcquisitionsLowerbound(state) {
      if(state.selectedAcquisitionsLowerbound != null && state.selectedAcquisitionsLowerbound != 'null')
        return JSON.parse(state.selectedAcquisitionsLowerbound)
      else
        return moment().subtract(defaultLowerBound, 'days').format('DD/MM/YYYY HH:mm')
    },
    selectedAcquisitionsUpperbound(state) {
      if(state.selectedAcquisitionsUpperbound != null && state.selectedAcquisitionsUpperbound != 'null')
        return JSON.parse(state.selectedAcquisitionsUpperbound)
      else
        return moment().format('DD/MM/YYYY HH:mm')
    },
    /* End Acquisitions */

    /* Consumptions */
    selectedConsumptionsDevices(state) {
      return JSON.parse(state.selectedConsumptionsDevices)
    },
    selectedConsumptionsParameters() {
      return 264;
      // return JSON.parse(state.selectedConsumptionsParameters)
    },
    selectedConsumptionsAggregationFrequency(state) {
      if(state.selectedConsumptionsAggregationFrequency != null && state.selectedConsumptionsAggregationFrequency != 'null')
        return JSON.parse(state.selectedConsumptionsAggregationFrequency)
      else
        return 'DAILY';
    },
    selectedConsumptionsAggregationMode() {
      return 'CONS';
      // return JSON.parse(state.selectedConsumptionsAggregationMode)
    },
    selectedConsumptionsLowerbound(state) {
      if(state.selectedConsumptionsLowerbound != null && state.selectedConsumptionsLowerbound != 'null')
        return JSON.parse(state.selectedConsumptionsLowerbound)
      else
        return moment().subtract(defaultLowerBound, 'days').format('DD/MM/YYYY')
    },
    selectedConsumptionsUpperbound(state) {
      if(state.selectedConsumptionsUpperbound != null && state.selectedConsumptionsUpperbound != 'null')
        return JSON.parse(state.selectedConsumptionsUpperbound)
      else
        return moment().format('DD/MM/YYYY')
    },
    /* End Consumptions */

    /* Alarms */
    selectedAlarmsDevices(state) {
      return JSON.parse(state.selectedAlarmsDevices)
    },
    selectedAlarmsParameters(state) {
      return JSON.parse(state.selectedAlarmsParameters)
    },
    selectedAlarmsLowerbound(state) {
      return JSON.parse(state.selectedAlarmsLowerbound)
    },
    selectedAlarmsUpperbound(state) {
      return JSON.parse(state.selectedAlarmsUpperbound)
    },
    /* End Alarms */

    /* Reports */
    selectedReport(state) {
      if(state.selectedReport !== 'undefined' && state.selectedReport != null && state.selectedReport != 'null') {
        return JSON.parse(state.selectedReport)
      } else
        return null
    },
    selectedReportLowerbound(state) {
      return JSON.parse(state.selectedReportLowerbound)
    },
    selectedReportUpperbound(state) {
      return JSON.parse(state.selectedReportUpperbound)
    },
    /* End Reports */

  },

  mutations: { //Setter lo stato su localstorage
    login(state, response) {
      state.token = response.token;
      state.userType = response.userType;
      state.clientId = response.clientId;
      state.clientName = response.clientName;
      state.clientLogo = response.clientLogo;
      state.clientRole = response.clientRole;
      if (response.clientRole == 'master' && response.slaveClients) {
        state.slaveClients = response.slaveClients;
        state.selectedSlaveClient = response.selectedSlaveClient;        
      }
      if (response.clientSiteDefaultSiteId != null) {
        state.clientSiteDefaultSiteId = response.clientSiteDefaultSiteId;        
      }
    },
    logout(state) {
      state.token = null;
      state.userType = null;
      state.clientId = null;
      state.clientName = null;
      state.clientLogo = null;
      state.clientRole = null;
      state.slaveClients = null;
      state.selectedSlaveClient = null;

      state.clientSites = null;
      state.clientSiteDefaultSiteId = null;
      state.selectedSite = null;
      state.selectedSiteFull = null;
      state.selectedDashboard = null;
      /* Acquisitions */
      state.selectedAcquisitionsDevices = null;
      state.selectedAcquisitionsParameters = null;
      state.selectedAcquisitionsAggregationFrequency = null;
      state.selectedAcquisitionsAggregationMode = null;
      state.selectedAcquisitionsLowerbound = null;
      state.selectedAcquisitionsUpperbound = null;
      /* End Acquisitions */

      /* Consumptions */
      state.selectedConsumptionsDevices = null;
      state.selectedConsumptionsParameters = null;
      state.selectedConsumptionsAggregationFrequency = null;
      state.selectedConsumptionsAggregationMode = null;
      state.selectedConsumptionsLowerbound = null;
      state.selectedConsumptionsUpperbound = null;
      /* End Consumptions */
      
      /* Alarms */
      state.selectedAlarmsDevices = null;
      state.selectedAlarmsParameters = null;
      state.selectedAlarmsLowerbound = null;
      state.selectedAlarmsUpperbound = null;
      /* End Alarms */
      
      /* Reports */
      state.selectedReport = null;
      state.selectedReportLowerbound = null;
      state.selectedReportUpperbound = null;
      /* End Reports */
    },

    clientSites(state, response) {
      state.clientSites = response.clientSites
    },
    clientSiteDefaultSiteId(state, response) {
      state.clientSiteDefaultSiteId = response.clientSiteDefaultSiteId
    },
    selectedSite(state, response) {
      state.selectedSite = response.selectedSite
    }, 
    selectedSiteFull(state, response) {
      state.selectedSiteFull = response.selectedSiteFull
    }, 
    selectedDashboard(state, response) {
      state.selectedDashboard = response.selectedDashboard
    },
    changeClientId(state, response) {
      state.clientId = response.clientId
    },
    selectedSlaveClient(state, response) {
      state.selectedSlaveClient = response.selectedSlaveClient
    },

    /* Acquisitions */
    selectedAcquisitionsDevices(state, response) {
      state.selectedAcquisitionsDevices = response.selectedAcquisitionsDevices
    },
    selectedAcquisitionsParameters(state, response) {
      state.selectedAcquisitionsParameters = response.selectedAcquisitionsParameters
    },
    selectedAcquisitionsAggregationFrequency(state, response) {
      state.selectedAcquisitionsAggregationFrequency = response.selectedAcquisitionsAggregationFrequency
    },
    selectedAcquisitionsAggregationMode(state, response) {
      state.selectedAcquisitionsAggregationMode = response.selectedAcquisitionsAggregationMode
    },
    selectedAcquisitionsLowerbound(state, response) {
      state.selectedAcquisitionsLowerbound = response.selectedAcquisitionsLowerbound
    },
    selectedAcquisitionsUpperbound(state, response) {
      state.selectedAcquisitionsUpperbound = response.selectedAcquisitionsUpperbound
    },
    /* End Acquisitions */

    /* Consumptions */
    selectedConsumptionsDevices(state, response) {
      state.selectedConsumptionsDevices = response.selectedConsumptionsDevices
    },
    selectedConsumptionsParameters(state, response) {
      state.selectedConsumptionsParameters = response.selectedConsumptionsParameters
    },
    selectedConsumptionsAggregationFrequency(state, response) {
      state.selectedConsumptionsAggregationFrequency = response.selectedConsumptionsAggregationFrequency
    },
    selectedConsumptionsAggregationMode(state, response) {
      state.selectedConsumptionsAggregationMode = response.selectedConsumptionsAggregationMode
    },
    selectedConsumptionsLowerbound(state, response) {
      state.selectedConsumptionsLowerbound = response.selectedConsumptionsLowerbound
    },
    selectedConsumptionsUpperbound(state, response) {
      state.selectedConsumptionsUpperbound = response.selectedConsumptionsUpperbound
    },
    /* End Consumptions */

    /* Alarms */
    selectedAlarmsDevices(state, response) {
      state.selectedAlarmsDevices = response.selectedAlarmsDevices
    },
    selectedAlarmsParameters(state, response) {
      state.selectedAlarmsParameters = response.selectedAlarmsParameters
    },
    selectedAlarmsLowerbound(state, response) {
      state.selectedAlarmsLowerbound = response.selectedAlarmsLowerbound
    },
    selectedAlarmsUpperbound(state, response) {
      state.selectedAlarmsUpperbound = response.selectedAlarmsUpperbound
    },
    /* End Alarms */

    /* Reports */
    selectedReport(state, response) {
      state.selectedReport = response.selectedReport
    },
    selectedReportLowerbound(state, response) {
      state.selectedReportLowerbound = response.selectedReportLowerbound
    },
    selectedReportUpperbound(state, response) {
      state.selectedReportUpperbound = response.selectedReportUpperbound
    },
    /* End Reports */
  },

  actions: {

    login(context, data) {
      var request = {
        email: data.fields.email,
        password: data.fields.password,
        browser: "string",
        device: "string",
        ip: "127.0.0.1",
        os: "string",
      };
      
      var config = {};
      
      if (process.env.VUE_APP_DIGEST == 'true') {
        config = {
          headers: {
            'mispMessageDigest': getDigest(request),
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json'
          }
        }
      }
      
      return new Promise((resolve, reject) => {
        axios.post(axios.defaults.baseURL + '/EmonAccessManagement.Service/service/Login/json', request, config)
          .then(response => {
            const token = response.data.sessionToken;
            const userType = response.data.type;
            const clientRole = response.data.clientInfo.role;
            const clientId = response.data.clientInfo.clientId;
            const clientName = response.data.clientInfo.clientName;
            const clientLogo = response.data.clientInfo.logoClientUrl;
            const clientSiteDefaultSiteId = response.data.defaultSiteId != undefined ? response.data.defaultSiteId: null;
            
            localStorage.setItem('access_token', token)
            localStorage.setItem('user_type', userType)
            localStorage.setItem('client_id', clientId)
            localStorage.setItem('client_name', clientName)
            localStorage.setItem('client_logo', clientLogo)
            localStorage.setItem('client_role', clientRole)

            if(response.data.defaultSiteId != undefined) {
              context.commit('clientSiteDefaultSiteId', response.data.defaultSiteId)
              localStorage.setItem('client_site_default_site_id', response.data.defaultSiteId)              
            }

            if ((userType == 'admin' && clientRole == 'master' || userType == 'superadmin') && response.data.clientInfo['slaveClients'] != undefined) {
              //Inserisco nella lista degli slave il cliente corrente
              response.data.clientInfo['slaveClients'].push({clientId: clientId, clientName: clientName});
              
              const slaveClients = JSON.stringify(response.data.clientInfo['slaveClients']);
              localStorage.setItem('slave_clients', slaveClients)

              //Seleziono lo slave client
              const selectedSlaveClient = clientId;
              localStorage.setItem('selected_slave_client', selectedSlaveClient)

              context.commit('login', {token, userType, clientRole, clientId, clientName, clientLogo, clientSiteDefaultSiteId, slaveClients, selectedSlaveClient})
              
            }

            context.commit('login', {token, userType, clientRole, clientId, clientName, clientLogo, clientSiteDefaultSiteId})

            resolve(response)            
          })
          .catch(error => {
            if (error != undefined && error.response != undefined && error.response.data != undefined && error.response.data.mispErrorDTO.code != undefined)
              reject(error.response.data.mispErrorDTO.code);
            else
              reject(null);
          })
      })
    },

    logout(context) {
      if (context.getters.loggedIn) {
        var request = {
          sessionToken: context.state.token
        };
        
        var config = {};
        
        if (process.env.VUE_APP_DIGEST == 'true') {
          config = {
            headers: {
              'mispMessageDigest': getDigest(request),
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'
            }
          }
        }

        return new Promise((resolve, reject) => {
          axios.post(axios.defaults.baseURL + '/EmonAccessManagement.Service/service/Logout/json', request, config)
            .then(response => {
              localStorage.removeItem('access_token')
              localStorage.removeItem('client_sites')
              localStorage.removeItem('client_site_default_site_id')
              localStorage.removeItem('user_type')
              localStorage.removeItem('client_role')
              localStorage.removeItem('client_id')
              localStorage.removeItem('client_name')
              localStorage.removeItem('client_logo')
              localStorage.removeItem('slave_clients')
              localStorage.removeItem('selected_slave_client')
              localStorage.removeItem('selected_site')
              localStorage.removeItem('selected_dashboard')
              
              /* Acquisitions */
              localStorage.removeItem('selected_acquisitions_devices')
              localStorage.removeItem('selected_acquisitions_parameters')
              localStorage.removeItem('selected_acquisitions_aggregation_frequency')
              localStorage.removeItem('selected_acquisitions_aggregation_mode')
              localStorage.removeItem('selected_acquisitions_lowerbound')
              localStorage.removeItem('selected_acquisitions_upperbound')
              /* End Acquisitions */

              /* Consumptions */
              localStorage.removeItem('selected_consumptions_devices')
              localStorage.removeItem('selected_consumptions_parameters')
              localStorage.removeItem('selected_consumptions_aggregation_frequency')
              localStorage.removeItem('selected_consumptions_aggregation_mode')
              localStorage.removeItem('selected_consumptions_lowerbound')
              localStorage.removeItem('selected_consumptions_upperbound')
              /* End Consumptions */
              
              /* Alarms */
              localStorage.removeItem('selected_alarms_devices')
              localStorage.removeItem('selected_alarms_parameters')
              localStorage.removeItem('selected_alarms_lowerbound')
              localStorage.removeItem('selected_alarms_upperbound')
              /* End Alarms */
              
              /* Reports */
              localStorage.removeItem('selected_report')
              localStorage.removeItem('selected_report_lowerbound')
              localStorage.removeItem('selected_report_upperbound')
              /* End Reports */
              
              context.commit('logout')
              resolve(response)              
            })
            .catch(error => {
              localStorage.removeItem('access_token')
              localStorage.removeItem('client_sites')
              localStorage.removeItem('client_site_default_site_id')
              localStorage.removeItem('user_type')
              localStorage.removeItem('client_role')
              localStorage.removeItem('client_id')
              localStorage.removeItem('client_name')
              localStorage.removeItem('client_logo')
              localStorage.removeItem('slave_clients')
              localStorage.removeItem('selected_slave_client')
              localStorage.removeItem('selected_site')
              localStorage.removeItem('selected_dashboard')
              
              /* Acquisitions */
              localStorage.removeItem('selected_acquisitions_devices')
              localStorage.removeItem('selected_acquisitions_parameters')
              localStorage.removeItem('selected_acquisitions_aggregation_frequency')
              localStorage.removeItem('selected_acquisitions_aggregation_mode')
              localStorage.removeItem('selected_acquisitions_lowerbound')
              localStorage.removeItem('selected_acquisitions_upperbound')
              /* End Acquisitions */

              /* Consumptions */
              localStorage.removeItem('selected_consumptions_devices')
              localStorage.removeItem('selected_consumptions_parameters')
              localStorage.removeItem('selected_consumptions_aggregation_frequency')
              localStorage.removeItem('selected_consumptions_aggregation_mode')
              localStorage.removeItem('selected_consumptions_lowerbound')
              localStorage.removeItem('selected_consumptions_upperbound')
              /* End Consumptions */
              
              /* Alarms */
              localStorage.removeItem('selected_alarms_devices')
              localStorage.removeItem('selected_alarms_parameters')
              localStorage.removeItem('selected_alarms_lowerbound')
              localStorage.removeItem('selected_alarms_upperbound')
              /* End Alarms */
              
              /* Reports */
              localStorage.removeItem('selected_report')
              localStorage.removeItem('selected_report_lowerbound')
              localStorage.removeItem('selected_report_upperbound')
              /* End Reports */
              
              context.commit('logout')
              reject(error)
            })
        })
      } else {
        context.commit('logout')
      }
    },

    getClientSites(context, force) {
      if (context.state.clientSites !== null && (force == undefined || !force))
        return;

      if(force != undefined && force) {
        this.dispatch('changeClientSite', null, true)
      }

      var request = {
        clientId: context.state.clientId,          
        sessionToken: context.state.token,
        // cacheInfoDTO: {
        //   expireCacheKey: true,
        //   expireTimeInSecond: 0,
        //   forceCacheReload: true
        // },
      };
      
      var config = {};
      
      if (process.env.VUE_APP_DIGEST == 'true') {
        config = {
          headers: {
            'mispMessageDigest': getDigest(request),
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json'
          }
        }
      }
        
      return new Promise((resolve, reject) => {
        axios.post(axios.defaults.baseURL + '/EmonClientManagement.Service/service/GetClientSites/json', request, config)
        .then(response => {
          if(response.data['clientSites'] != undefined) {
            const clientSites = JSON.stringify(response.data['clientSites']);
            
            localStorage.setItem('client_sites', clientSites)
            context.commit('clientSites', { clientSites })
                                    
            // if(force != undefined && force && clientSites[0] != undefined)
            //   this.dispatch('changeClientSite', 0);
          }
                      
          resolve(response);
        })
        .catch(error => {
          if (error.response.data.mispErrorDTO.code != undefined)
            reject(error.response.data.mispErrorDTO.code);
          else
            reject(null);
        })
      })
    },

    changeClientSite(context, site, force) {
      if((force != undefined || !force) && site != undefined && context.state.selectedSite === site.siteId)
        return;
              
      if(site != undefined) {
        const selectedSite = site.siteId;
        localStorage.setItem('selected_site', selectedSite)
        context.commit('selectedSite', {selectedSite})
        
        const selectedSiteFull = JSON.stringify(site);
        localStorage.setItem('selected_site_full', selectedSiteFull)
        context.commit('selectedSiteFull', {selectedSiteFull})
      }   else {
        const selectedSite = null;
        localStorage.setItem('selected_site', selectedSite)
        context.commit('selectedSite', {selectedSite})
        
        const selectedSiteFull = JSON.stringify(null);
        localStorage.setItem('selected_site_full', selectedSiteFull)
        context.commit('selectedSiteFull', {selectedSiteFull})

      }
      
      if(context.state.selectedDashboard != null && context.state.selectedDashboard !== 'null') {
        localStorage.setItem('selected_dashboard', null)      
        // context.commit('selectedDashboard', null)
      }
      
      /* Acquisitions */
      if(context.state.selectedAcquisitionsDevices != null && context.state.selectedAcquisitionsDevices !== 'null') {
        localStorage.setItem('selected_acquisitions_devices', null)      
        // context.commit('selectedAcquisitionsDevices', null)
      }
      
      if(context.state.selectedAcquisitionsParameters != null && context.state.selectedAcquisitionsParameters !== 'null') {
        localStorage.setItem('selected_acquisitions_parameters', null)      
        // context.commit('selectedAcquisitionsParameters', null)
      }
      
      if(context.state.selectedAcquisitionsAggregationFrequency != null && context.state.selectedAcquisitionsAggregationFrequency !== 'null') {
        localStorage.setItem('selected_acquisitions_aggregation_frequency', null)      
        // context.commit('selectedAcquisitionsAggregationFrequency', null)
      }
      
      if(context.state.selectedAcquisitionsAggregationMode != null && context.state.selectedAcquisitionsAggregationMode !== 'null') {
        localStorage.setItem('selected_acquisitions_aggregation_mode', null)      
        // context.commit('selectedAcquisitionsAggregationMode', null)
      }
      
      if(context.state.selectedAcquisitionsLowerbound != null && context.state.selectedAcquisitionsLowerbound !== 'null') {
        localStorage.setItem('selected_acquisitions_lowerbound', null)      
        // context.commit('selectedAcquisitionsLowerbound', null)
      }
      
      if(context.state.selectedAcquisitionsUpperbound != null && context.state.selectedAcquisitionsUpperbound !== 'null') {
        localStorage.setItem('selected_acquisitions_upperbound', null)      
        // context.commit('selectedAcquisitionsUpperbound', null)
      }
      /* End Acquisitions */
      
      /* Consumptions */
      if(context.state.selectedConsumptionsDevices != null && context.state.selectedConsumptionsDevices !== 'null') {
        localStorage.setItem('selected_consumptions_devices', null)      
        // context.commit('selectedConsumptionsDevices', null)
      }
      
      if(context.state.selectedConsumptionsParameters != null && context.state.selectedConsumptionsParameters !== 'null') {
        localStorage.setItem('selected_consumptions_parameters', null)      
        // context.commit('selectedConsumptionsParameters', null)
      }
      
      if(context.state.selectedConsumptionsAggregationFrequency != null && context.state.selectedConsumptionsAggregationFrequency !== 'null') {
        localStorage.setItem('selected_consumptions_aggregation_frequency', null)      
        // context.commit('selectedConsumptionsAggregationFrequency', null)
      }
      
      if(context.state.selectedConsumptionsAggregationMode != null && context.state.selectedConsumptionsAggregationMode !== 'null') {
        localStorage.setItem('selected_consumptions_aggregation_mode', null)      
        // context.commit('selectedConsumptionsAggregationMode', null)
      }
      
      if(context.state.selectedConsumptionsLowerbound != null && context.state.selectedConsumptionsLowerbound !== 'null') {
        localStorage.setItem('selected_consumptions_lowerbound', null)      
        // context.commit('selectedConsumptionsLowerbound', null)
      }
      
      if(context.state.selectedConsumptionsUpperbound != null && context.state.selectedConsumptionsUpperbound !== 'null') {
        localStorage.setItem('selected_consumptions_upperbound', null)      
        // context.commit('selectedConsumptionsUpperbound', null)
      }
      /* End Consumptions */
      
      /* Alarms */
      if(context.state.selectedAlarmsDevices != null && context.state.selectedAlarmsDevices !== 'null') {
        localStorage.setItem('selected_alarms_devices', null)      
        // context.commit('selectedAlarmsDevices', null)
      }
      
      if(context.state.selectedAlarmsParameters != null && context.state.selectedAlarmsParameters !== 'null') {
        localStorage.setItem('selected_alarms_parameters', null)      
        // context.commit('selectedAlarmsParameters', null)
      }
      
      if(context.state.selectedAlarmsLowerbound != null && context.state.selectedAlarmsLowerbound !== 'null') {
        localStorage.setItem('selected_alarms_lowerbound', null)      
        // context.commit('selectedAlarmsLowerbound', null)
      }
      
      if(context.state.selectedAlarmsUpperbound != null && context.state.selectedAlarmsUpperbound !== 'null') {
        localStorage.setItem('selected_alarms_upperbound', null)      
        // context.commit('selectedAlarmsUpperbound', null)
      }
      /* End Alarms */
      
      /* Reports */
      if(context.state.selectedReport != null && context.state.selectedReport !== 'null') {
        localStorage.setItem('selected_report', null)      
        // context.commit('selectedReport', null)
      }
      
      if(context.state.selectedReportLowerbound != null && context.state.selectedReportLowerbound !== 'null') {
        localStorage.setItem('selected_report_lowerbound', null)      
        // context.commit('selectedReportLowerbound', null)
      }
      
      if(context.state.selectedReportUpperbound != null && context.state.selectedReportUpperbound !== 'null') {
        localStorage.setItem('selected_report_upperbound', null)      
        // context.commit('selectedReportUpperbound', null)
      }
      /* End Reports */
            
    },   
    
    changeClientSlave(context, index) {
      if(context.state.selectedSlaveClient === index)
        return;

      const selectedSlaveClient = index;
      localStorage.setItem('selected_slave_client', selectedSlaveClient)
      context.commit('selectedSlaveClient', {selectedSlaveClient})

      localStorage.setItem('client_id', selectedSlaveClient)
      context.commit('changeClientId', {clientId: selectedSlaveClient})

      this.dispatch('getClientSites', true);                  
    },   

    changeMonitorDashboard(context, dashboard) {
      //Resetto prima la dashboard
      const empty = JSON.stringify({});
      localStorage.setItem('selected_dashboard', empty)
      context.commit('selectedDashboard', {empty})

      const selectedDashboard = JSON.stringify(dashboard);
      localStorage.setItem('selected_dashboard', selectedDashboard)
      context.commit('selectedDashboard', {selectedDashboard})
    },   

    /* Acquisitions */
    changeAcquisitionsDevices(context, devices) {
      const selectedAcquisitionsDevices = JSON.stringify(devices);
      localStorage.setItem('selected_acquisitions_devices', selectedAcquisitionsDevices)
      context.commit('selectedAcquisitionsDevices', {selectedAcquisitionsDevices})

      //Resetto parametro selezionato
      const selectedAcquisitionsParameters = JSON.stringify(null);
      localStorage.removeItem('selected_acquisitions_parameters')
      context.commit('selectedAcquisitionsParameters', {selectedAcquisitionsParameters})
    },   
    
    changeAcquisitionsParameters(context, parameters) {
      const selectedAcquisitionsParameters = JSON.stringify(parameters);
      localStorage.setItem('selected_acquisitions_parameters', selectedAcquisitionsParameters)
      context.commit('selectedAcquisitionsParameters', {selectedAcquisitionsParameters})
    },
    
    changeAcquisitionsAggregationFrequency(context, aggregationFrequency) {
      const selectedAcquisitionsAggregationFrequency = JSON.stringify(aggregationFrequency);
      localStorage.setItem('selected_acquisitions_aggregation_frequency', selectedAcquisitionsAggregationFrequency)
      context.commit('selectedAcquisitionsAggregationFrequency', {selectedAcquisitionsAggregationFrequency})
    },
    
    changeAcquisitionsAggregationMode(context, aggregationMode) {
      const selectedAcquisitionsAggregationMode = JSON.stringify(aggregationMode);
      localStorage.setItem('selected_acquisitions_aggregation_mode', selectedAcquisitionsAggregationMode)
      context.commit('selectedAcquisitionsAggregationMode', {selectedAcquisitionsAggregationMode})
    },
    
    changeAcquisitionsLowerbound(context, lowerbound) {
      const selectedAcquisitionsLowerbound = JSON.stringify(lowerbound);
      localStorage.setItem('selected_acquisitions_lowerbound', selectedAcquisitionsLowerbound)
      context.commit('selectedAcquisitionsLowerbound', {selectedAcquisitionsLowerbound})
    },
    
    changeAcquisitionsUpperbound(context, upperbound) {
      const selectedAcquisitionsUpperbound = JSON.stringify(upperbound);
      localStorage.setItem('selected_acquisitions_upperbound', selectedAcquisitionsUpperbound)
      context.commit('selectedAcquisitionsUpperbound', {selectedAcquisitionsUpperbound})
    },
    /* End Acquisitions */

    /* Consumptions */
    changeConsumptionsDevices(context, devices) {
      const selectedConsumptionsDevices = JSON.stringify(devices);
      localStorage.setItem('selected_consumptions_devices', selectedConsumptionsDevices)
      context.commit('selectedConsumptionsDevices', {selectedConsumptionsDevices})

      //Resetto parametro selezionato
      const selectedConsumptionsParameters = JSON.stringify(null);
      localStorage.removeItem('selected_consumptions_parameters')
      context.commit('selectedConsumptionsParameters', {selectedConsumptionsParameters})
    },   
    
    changeConsumptionsParameters(context, parameters) {
      const selectedConsumptionsParameters = JSON.stringify(parameters);
      localStorage.setItem('selected_consumptions_parameters', selectedConsumptionsParameters)
      context.commit('selectedConsumptionsParameters', {selectedConsumptionsParameters})
    },
    
    changeConsumptionsAggregationFrequency(context, aggregationFrequency) {
      const selectedConsumptionsAggregationFrequency = JSON.stringify(aggregationFrequency);
      localStorage.setItem('selected_consumptions_aggregation_frequency', selectedConsumptionsAggregationFrequency)
      context.commit('selectedConsumptionsAggregationFrequency', {selectedConsumptionsAggregationFrequency})
    },
    
    changeConsumptionsAggregationMode(context, aggregationMode) {
      const selectedConsumptionsAggregationMode = JSON.stringify(aggregationMode);
      localStorage.setItem('selected_consumptions_aggregation_mode', selectedConsumptionsAggregationMode)
      context.commit('selectedConsumptionsAggregationMode', {selectedConsumptionsAggregationMode})
    },
    
    changeConsumptionsLowerbound(context, lowerbound) {
      const selectedConsumptionsLowerbound = JSON.stringify(lowerbound);
      localStorage.setItem('selected_consumptions_lowerbound', selectedConsumptionsLowerbound)
      context.commit('selectedConsumptionsLowerbound', {selectedConsumptionsLowerbound})
    },
    
    changeConsumptionsUpperbound(context, upperbound) {
      const selectedConsumptionsUpperbound = JSON.stringify(upperbound);
      localStorage.setItem('selected_consumptions_upperbound', selectedConsumptionsUpperbound)
      context.commit('selectedConsumptionsUpperbound', {selectedConsumptionsUpperbound})
    },
    /* End Acquisitions */
    
    /* Alarms */
    changeAlarmsDevices(context, devices) {
      const selectedAlarmsDevices = JSON.stringify(devices);
      localStorage.setItem('selected_alarms_devices', selectedAlarmsDevices)
      context.commit('selectedAlarmsDevices', {selectedAlarmsDevices})

      //Resetto parametro selezionato
      const selectedAlarmsParameters = JSON.stringify(null);
      localStorage.removeItem('selected_alarms_parameters')
      context.commit('selectedAlarmsParameters', {selectedAlarmsParameters})
    },   
    
    changeAlarmsParameters(context, parameters) {
      const selectedAlarmsParameters = JSON.stringify(parameters);
      localStorage.setItem('selected_alarms_parameters', selectedAlarmsParameters)
      context.commit('selectedAlarmsParameters', {selectedAlarmsParameters})
    },
    
    changeAlarmsAggregationFrequency(context, aggregationFrequency) {
      const selectedAlarmsAggregationFrequency = JSON.stringify(aggregationFrequency);
      localStorage.setItem('selected_alarms_aggregation_frequency', selectedAlarmsAggregationFrequency)
      context.commit('selectedAlarmsAggregationFrequency', {selectedAlarmsAggregationFrequency})
    },
    
    changeAlarmsAggregationMode(context, aggregationMode) {
      const selectedAlarmsAggregationMode = JSON.stringify(aggregationMode);
      localStorage.setItem('selected_alarms_aggregation_mode', selectedAlarmsAggregationMode)
      context.commit('selectedAlarmsAggregationMode', {selectedAlarmsAggregationMode})
    },
    
    changeAlarmsLowerbound(context, lowerbound) {
      const selectedAlarmsLowerbound = JSON.stringify(lowerbound);
      localStorage.setItem('selected_alarms_lowerbound', selectedAlarmsLowerbound)
      context.commit('selectedAlarmsLowerbound', {selectedAlarmsLowerbound})
    },
    
    changeAlarmsUpperbound(context, upperbound) {
      const selectedAlarmsUpperbound = JSON.stringify(upperbound);
      localStorage.setItem('selected_alarms_upperbound', selectedAlarmsUpperbound)
      context.commit('selectedAlarmsUpperbound', {selectedAlarmsUpperbound})
    },
    /* End Alarms */

    /* Reports */
    changeReport(context, report) {
      const selectedReport = JSON.stringify(report.value);
      localStorage.setItem('selected_report', selectedReport)
      context.commit('selectedReport', {selectedReport})
      
      //Resetto Lower & Upperbound selezionato
      const selectedReportLowerbound = JSON.stringify(null);
      localStorage.setItem('selected_report_lowerbound', selectedReportLowerbound)
      context.commit('selectedReportLowerbound', {selectedReportLowerbound})
      
      const selectedReportUpperbound = JSON.stringify(null);
      localStorage.setItem('selected_report_upperbound', selectedReportUpperbound)
      context.commit('selectedReportUpperbound', {selectedReportUpperbound})
    },   
    
    changeReportLowerbound(context, lowerbound) {
      const selectedReportLowerbound = JSON.stringify(lowerbound);
      localStorage.setItem('selected_report_lowerbound', selectedReportLowerbound)
      context.commit('selectedReportLowerbound', {selectedReportLowerbound})
    },
    
    changeReportUpperbound(context, upperbound) {
      const selectedReportUpperbound = JSON.stringify(upperbound);
      localStorage.setItem('selected_report_upperbound', selectedReportUpperbound)
      context.commit('selectedReportUpperbound', {selectedReportUpperbound})
    },
    /* End Alarms */

    getDashboardConfig(context, parameter) {
      if(context.state.clientSites === null)
        return;
      
      return new Promise((resolve, reject) => {

        var request = {
          clientId: context.state.clientId,
          sessionToken: context.state.token,
          // "cacheInfoDTO": {
          //   "expireCacheKey": true,
          //   "expireTimeInSecond": 0,
          //   "forceCacheReload": true
          // },
        };

        if(!parameter.generalDashboard) {
          var selectedDashboard = context.getters.selectedDashboard;

          request['site'] = context.state.selectedSite;
          
          if(selectedDashboard.department != undefined)
            request['department'] = selectedDashboard.department.id;
          if(selectedDashboard.machine != undefined)
            request['machine'] = selectedDashboard.machine.id;
          if(selectedDashboard.device != undefined)
            request['device'] = selectedDashboard.device.id;     
        } else if(context.state.clientSiteDefaultSiteId != null) {
          //Caso dashboard generale verifico se è attivo il sito di default
          request['site'] = context.state.clientSiteDefaultSiteId.toString();
        }
        
        var config = {};
        
        if (process.env.VUE_APP_DIGEST == 'true') {
          config = {
            headers: {
              'mispMessageDigest': getDigest(request),
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'
            }
          }
        }
        
        axios.post(axios.defaults.baseURL + '/EmonClientManagement.Service/service/GetDashboardConfig/json', request, config)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error.response.data.mispErrorDTO.code != undefined)
              reject(error.response.data.mispErrorDTO.code);
            else
              reject(null);
          })
      })      
    },
    
    getClientDeviceParameters(context, parameter) {
      return new Promise((resolve, reject) => {
        
        var keyword = parameter['page'].charAt(0).toUpperCase() + parameter['page'].slice(1);

        var selectedDevice = context.getters['selected' + keyword + 'Devices'];

        if(parameter['page'] == 'acquisitions' && selectedDevice.multidevice != undefined && selectedDevice.devices != undefined && selectedDevice.devices[0])
          selectedDevice = selectedDevice.devices[0];

        var request = {
          clientId: context.state.clientId,
          sessionToken: context.state.token,
          deviceId: selectedDevice.device.id
        };

        var config = {};
        
        if (process.env.VUE_APP_DIGEST == 'true') {
          config = {
            headers: {
              'mispMessageDigest': getDigest(request),
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'
            }
          }
        }

        axios.post(axios.defaults.baseURL + '/EmonClientManagement.Service/service/GetClientDeviceParameters/json', request, config)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error.response.data.mispErrorDTO.code != undefined)
              reject(error.response.data.mispErrorDTO.code);
            else
              reject(null);
          })
      })      
    },
    
    getClientDeviceAlarms(context) {
      return new Promise((resolve, reject) => {
        
        var request = {
          clientId: context.state.clientId,
          sessionToken: context.state.token,          
        };
        
        request['siteId'] = context.state.selectedSite;
          
        if(context.getters.selectedAlarmsDevices.department != undefined)
          request['departmentId'] = context.getters.selectedAlarmsDevices.department.id;          
        if(context.getters.selectedAlarmsDevices.machine != undefined)
          request['machineId'] = context.getters.selectedAlarmsDevices.machine.id;          
        if(context.getters.selectedAlarmsDevices.device != undefined)
          request['deviceId'] = context.getters.selectedAlarmsDevices.device.id;     
          
        var config = {};
        
        if (process.env.VUE_APP_DIGEST == 'true') {
          config = {
            headers: {
              'mispMessageDigest': getDigest(request),
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'
            }
          }
        }

        axios.post(axios.defaults.baseURL + '/EmonClientManagement.Service/service/GetClientDeviceAlarms/json', request, config)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error.response.data.mispErrorDTO.code != undefined)
              reject(error.response.data.mispErrorDTO.code);
            else
              reject(null);
          })
      })      
    },
    
    getTSData(context, parameter) {
      
      return new Promise((resolve, reject) => {

        var request = {
          clientId: context.state.clientId,
          sessionToken: context.state.token,
          devicesQueries: parameter.devicesQueries
        };
        
        var config = {};
        
        if (process.env.VUE_APP_DIGEST == 'true') {
          config = {
            headers: {
              'mispMessageDigest': getDigest(request),
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'
            }
          }
        }
                
        axios.post(axios.defaults.baseURL + '/EmonDataRetriever.Service/service/GetTSData/json', request, config)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error.response.data.mispErrorDTO.code != undefined)
              reject(error.response.data.mispErrorDTO.code);
            else
              reject(null);
          })
      })      
    },
    
    getTSChartData(context, parameter) {
      
      return new Promise((resolve, reject) => {

        var config = {};
        
        if (process.env.VUE_APP_DIGEST == 'true') {
          config = {
            headers: {
              'mispMessageDigest': getDigest(parameter.request),
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'
            }
          }
        }
                
        axios.post(axios.defaults.baseURL + '/EmonDataRetriever.Service/service/GetTSChartData/json', parameter.request, config)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error.response.data.mispErrorDTO.code != undefined)
              reject(error.response.data.mispErrorDTO.code);
            else
              reject(null);
          })
      })      
    },

    getTSFile(context, parameter) {
      
      return new Promise((resolve, reject) => {

        var config = {};
        
        if (process.env.VUE_APP_DIGEST == 'true') {
          config = {
            headers: {
              'mispMessageDigest': getDigest(parameter.request),
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'
            }
          }
        }
                
        axios.post(axios.defaults.baseURL + '/EmonDataRetriever.Service/service/GetTSFile/json', parameter.request, config)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error.response.data.mispErrorDTO.code != undefined)
              reject(error.response.data.mispErrorDTO.code);
            else
              reject(null);
          })
      })      
    },

    getClientAlarms(context, parameter) {
      return new Promise((resolve, reject) => {
                
        var request = {
          clientId: context.state.clientId,
          sessionToken: context.state.token,          
        };

        if(parameter.checkId != undefined)
          request['checkId'] = parameter.checkId;
        
        if(parameter.deviceIds != undefined)
          request['deviceIds'] = parameter.deviceIds;

        var config = {};
      
        if (process.env.VUE_APP_DIGEST == 'true') {
          config = {
            headers: {
              'mispMessageDigest': getDigest(request),
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'
            }
          }
        }

        axios.post(axios.defaults.baseURL + '/EmonAlarmManagement.Service/service/GetClientAlarms/json', request, config)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error.response.data.mispErrorDTO.code != undefined)
              reject(error.response.data.mispErrorDTO.code);
            else
              reject(null);
          })
      })      
    },
    
    getAlarmLog(context, parameter) {
      return new Promise((resolve, reject) => {
                
        var request = {
          clientId: context.state.clientId,
          sessionToken: context.state.token,   
          aqDatetimeLowerbound: parameter.aqDatetimeLowerbound,
          aqDatetimeUpperbound: parameter.aqDatetimeUpperbound
        };

        if(parameter.checkId != undefined)
          request['checkId'] = parameter.checkId;
        
        if(parameter.deviceIds != undefined)
          request['deviceId'] = parameter.deviceIds[0];

        var config = {};
      
        if (process.env.VUE_APP_DIGEST == 'true') {
          config = {
            headers: {
              'mispMessageDigest': getDigest(request),
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'
            }
          }
        }

        axios.post(axios.defaults.baseURL + '/EmonAlarmManagement.Service/service/GetAlarmLog/json', request, config)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error.response.data.mispErrorDTO.code != undefined)
              reject(error.response.data.mispErrorDTO.code);
            else
              reject(null);
          })
      })      
    },

    getClientReports(context) {
      return new Promise((resolve, reject) => {
                
        var request = {
          clientId: context.state.clientId,
          sessionToken: context.state.token,   
          // "cacheInfoDTO": {
          //   "expireCacheKey": true,
          //   "expireTimeInSecond": 0,
          //   "forceCacheReload": true
          // },              
        };

        var config = {};
      
        if (process.env.VUE_APP_DIGEST == 'true') {
          config = {
            headers: {
              'mispMessageDigest': getDigest(request),
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'
            }
          }
        }

        axios.post(axios.defaults.baseURL + '/EmonClientManagement.Service/service/GetClientReports/json', request, config)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error.response.data.mispErrorDTO.code != undefined)
              reject(error.response.data.mispErrorDTO.code);
            else
              reject(null);
          })
      })      
    },
    
    getReportData(context, parameter) {
      return new Promise((resolve, reject) => {
                
        var request = {
          clientId: context.state.clientId,
          sessionToken: context.state.token,
          aqDatetimeLowerbound: parameter.aqDatetimeLowerbound,
          aqDatetimeUpperbound: parameter.aqDatetimeUpperbound,                 
          reportName: parameter.reportName,             
        };

        var config = {};
      
        if (process.env.VUE_APP_DIGEST == 'true') {
          config = {
            headers: {
              'mispMessageDigest': getDigest(request),
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'
            }
          }
        }

        axios.post(axios.defaults.baseURL + '/EmonDataRetriever.Service/service/GetTSReportData/json', request, config)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error.response.data.mispErrorDTO.code != undefined)
              reject(error.response.data.mispErrorDTO.code);
            else
              reject(null);
          })
      })      
    },

    getReportFile(context, parameter) {
      
      return new Promise((resolve, reject) => {

        var config = {};
        
        if (process.env.VUE_APP_DIGEST == 'true') {
          config = {
            headers: {
              'mispMessageDigest': getDigest(parameter.request),
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'
            }
          }
        }
                
        axios.post(axios.defaults.baseURL + '/EmonDataRetriever.Service/service/GetTSReportFile/json', parameter.request, config)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error.response.data.mispErrorDTO.code != undefined)
              reject(error.response.data.mispErrorDTO.code);
            else
              reject(null);
          })
      })      
    },
    
    









    /*
    test(context) {

      var request = {
        clientId: context.state.clientId,
        sessionToken: context.state.token,
        // siteId: context.state.selectedSite
      };

      var config = {};
        
      if (process.env.VUE_APP_DIGEST == 'true') {
        config = {
          headers: {
            'mispMessageDigest': getDigest(request),
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json'
          }
        }
      }
      
      return new Promise((resolve, reject) => {
        axios.post(axios.defaults.baseURL + '/EmonClientManagement.Service/service/GetDashboardTree/json', request, config)
          .then(response => {
            console.log(response)

            resolve(response)

          })
          .catch(error => {
            console.log(error);
            if (error.response.data.mispErrorDTO.code != undefined)
              reject(error.response.data.mispErrorDTO.code);
            else
              reject(null);
          })
      })
    },
    */
  }
})
